import { combineReducers } from 'redux'
import {
	dadataFakeResponsesSlice,
	drsFakeResponsesSlice,
	krDrsFakeResponsesSlice,
} from 'Pages/admin'

export const fakeResponsesSlice = combineReducers({
	[krDrsFakeResponsesSlice.name]: krDrsFakeResponsesSlice.reducer,
	[drsFakeResponsesSlice.name]: drsFakeResponsesSlice.reducer,
	[dadataFakeResponsesSlice.name]: dadataFakeResponsesSlice.reducer,
})
